/**
 * Normalizacao dos meses de referencia selecionados no SeletorOrigemMeta.
 *
 * O v-select usa `item-value="valor"` (sem `return-object`), entao o
 * Vuetify ja emite apenas o `.valor` de cada item de `opcoesMeses`
 * (Array<{ano_ref, mes_ref}>) no evento `@change`. Esta funcao garante
 * esse shape do contrato e ordena cronologicamente, independente da ordem
 * de clique do usuario. Tambem aceita defensivamente o item completo
 * ({label, valor}) caso o binding do v-select volte a mudar no futuro.
 */

/**
 * @param {Array<{label:string, valor:{ano_ref:number, mes_ref:number}}|{ano_ref:number, mes_ref:number}>} itens
 * @returns {Array<{ano_ref:number, mes_ref:number}>}
 */
export function normalizarMeses(itens) {
  return (itens || [])
    .map(item => (item && item.valor ? item.valor : item))
    .map(v => ({ ano_ref: v.ano_ref, mes_ref: v.mes_ref }))
    .sort((a, b) => a.ano_ref - b.ano_ref || a.mes_ref - b.mes_ref);
}
